import { useState } from 'react';

export const CodeApi2 = () => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div>
      <code>{"import React, { useState, useEffect } from 'react';"}</code>
      <br />
      <code>{"import axios from 'axios';"}</code>
      <br />
      <br />
      <code>{'const TaskList = () => {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [tasks, setTasks] = useState([]);'}{' '}
      </code>
      <span style={{ color: '#999', fontSize: `${sValue}px` }}>
        // State for tasks
      </span>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [loading, setLoading] = useState(true);'}{' '}
      </code>
      <span style={{ color: '#999', fontSize: `${sValue}px` }}>
        // Loading state
      </span>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [error, setError] = useState(null);'}{' '}
      </code>
      <span style={{ color: '#999', fontSize: `${sValue}px` }}>
        // Error state
      </span>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'useEffect(() => {'}</code>
      <br />
      <span
        style={{
          paddingLeft: `${pValue + pValue}px`,
          color: '#999',
          fontSize: `${sValue}px`
        }}
      >
        // Fetch tasks when the component mounts
      </span>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'const fetchTasks = async () => {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'try {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {"const response = await axios.get('https://api.example.com/tasks');"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setTasks(response.data);'}{' '}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'} catch (error) {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setError(error);'}{' '}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'} finally {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setLoading(false);'}
      </code>{' '}
      <span style={{ color: '#999', fontSize: `${sValue}px` }}>
        // Always set loading to false after request completes
      </span>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'};'}</code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'fetchTasks();'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'}, []);'} </code>
      <span style={{ color: '#999', fontSize: `${sValue}px` }}>
        // Empty dependency array means this effect runs once on mount
      </span>
      <br />
      <br />
      <span
        style={{
          color: '#999',
          paddingLeft: `${pValue}px`,
          fontSize: `${sValue}px`
        }}
      >
        // Rendering logic based on loading, error, or data
      </span>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'if (loading) return <p>Loading tasks...</p>;'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'if (error) return <p>Error loading tasks: {error.message}</p>;'}
      </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'return ('}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'<ul>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'{tasks.map(task => ('}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'<li key={task.id}>{task.title}</li>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'))}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'</ul>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{');'}</code>
      <br />
      <code>{'};'}</code>
      <br />
      <br />
      <code>{'export default TaskList;'}</code>
    </div>
  );
};
